import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { XIcon } from "lucide-react";
import type { Purchase } from "../types/megapack";
import { E } from "./Emoji";
type PurchaseNotificationProps = {
  /** Compras confirmadas reales desde la integración con pedidos */
  purchases: Purchase[];
  /** Vista previa del diseño mientras no haya compras reales */
  previewItem?: Purchase | null;
};
export function PurchaseNotification({
  purchases,
  previewItem = null
}: PurchaseNotificationProps) {
  const isPreview = purchases.length === 0;
  const items = isPreview ? previewItem ? [previewItem] : [] : purchases;
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (items.length === 0 || dismissed) return;
    const t = window.setTimeout(() => setVisible(true), 3500);
    return () => window.clearTimeout(t);
  }, [items.length, dismissed]);
  useEffect(() => {
    if (isPreview || items.length < 2 || dismissed) return;
    const id = window.setInterval(() => {
      setVisible(false);
      window.setTimeout(() => {
        setIndex(i => (i + 1) % items.length);
        setVisible(true);
      }, 400);
    }, 9000);
    return () => window.clearInterval(id);
  }, [isPreview, items.length, dismissed]);
  if (items.length === 0) return null;
  const item = items[index];
  return <div className="pointer-events-none fixed bottom-4 left-4 z-50 w-[calc(100%-2rem)] max-w-[290px]" data-id="element-45" data-mp="19nbt5przj9f0">
      <AnimatePresence data-id="element-46" data-mp="1ehy63xdpta17">
        {visible && !dismissed && <motion.div role="status" initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative rounded-xl border border-line/70 bg-abyss p-4 pr-9 shadow-[0_12px_32px_rgba(0,0,0,0.7)]" data-id="element-47" data-mp="zsjt8faxkah2">
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="absolute right-2 top-2 rounded p-1 text-mute transition-colors duration-150 ease-out hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-sky" data-id="element-48" data-mp="2xgnpyr79l4ge">
              <XIcon className="h-4 w-4" data-id="element-49" data-mp="3gcm587f8f860" />
            </button>
            <p className="flex items-center gap-1.5 text-[11px] font-black uppercase tracking-wider text-bright" data-id="element-50" data-mp="3bekm5mht38uj">
              <span className="h-1.5 w-1.5 rounded-full bg-bright" data-id="element-51" data-mp="37ch9iujehy7o" />
              {isPreview ? "Vista previa" : "Compra verificada"}
            </p>
            <p className="mt-1.5 text-sm text-white" data-id="element-52" data-mp="32dmi547db1by">
              <span className="font-black" data-id="element-53" data-mp="1vyd8j4eeb9t4">{item.name}</span> de {item.location}
            </p>
            <p className="text-sm text-white" data-id="element-54" data-mp="1qy7krzb8y7gb">
              compró <span className="font-black text-bright" data-id="element-55" data-mp="1r0tt415yoqzl">{item.product}</span> <E data-id="element-56" data-mp="6hrc0r3ecr4g">🧺</E>
            </p>
            <p className="mt-1 text-xs text-mute" data-id="element-57" data-mp="6elovhebvzbd">{item.timeAgo}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}